module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split2#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split3#copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617750823_Split5#chap1"
    }
  }, [_vm._v("Chapter 1: Big Pimpin’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617750823_Split6#chap2"
    }
  }, [_vm._v("Chapter 2: Dead Homiez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617750823_Split7#chap3"
    }
  }, [_vm._v("Chapter 3: Lyrics of Fury")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617750823_Split8#chap4"
    }
  }, [_vm._v("Chapter 4: Never Seen a Man Cry Until I Seen a Man Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9781617750823_Split9#chap5"
    }
  }, [_vm._v("Chapter 5: Lookin’ for the Perfect Beat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split10#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Amerikkka’s Most Wanted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split11#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: You Must Learn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split12#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The Message")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split13#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Black Steel in the Hour of Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split14#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Blueprint for Hip Hop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split15#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Sound of the Police")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split16#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Criminal Minded")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split17#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Party for the Right to Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split18#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Made You Look")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split19#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Ante Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split20#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Round the Way Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split21#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Da Art of Storytellin’ Part 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split22#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Otha Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split23#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Talkin’ All That Jazz")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split24#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Things Done Changed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split25#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: As the Rhyme Goes On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split26#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Can’t Truss It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split27#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Crank That")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split28#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: What You Know")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split29#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Soul Survivor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split30#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: All of the Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split31#chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: The Scenario")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split32#chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: It’s Like That")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split33#chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: Time for Sum Aksion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/9781617750823_Split34#chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: Empire State of Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/lost_cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('i', [_vm._v("The Lost Treasures of R&B")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Nelson George")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/akb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Akashic Books")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4ba1e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781617750823_Split4.vue
// module id = 66
// module chunks = 0